module.exports = __webpack_public_path__ + "img/intent_1.2fc16791.png";